import { Instagram, Facebook, Linkedin } from "lucide-react";
import { Container } from "./Container";
import { Logo } from "./Logo";
import { scrollToId } from "./scrollTo";

const LINKS = [
  { id: "hero", label: "Начало" },
  { id: "about", label: "Кои сме ние" },
  { id: "prices", label: "Цени" },
  { id: "clients", label: "Клиенти" },
  { id: "contact", label: "Контакти" },
];

const SOCIALS = [
  { icon: Instagram, href: "https://instagram.com/bulbit.advertising", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/share/1LbZBP76qR/", label: "Facebook" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/bulb-it-studio/", label: "LinkedIn" },
];

export const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#15181C] border-t border-[rgba(255,255,255,.14)] py-14" data-testid="footer">
      <Container className="flex flex-col gap-12">
        <a
          href="#hero"
          onClick={scrollToId("hero")}
          className="inline-flex w-fit"
          data-testid="footer-logo"
        >
          <Logo height={54} />
        </a>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <nav className="flex flex-wrap gap-x-6 gap-y-3" data-testid="footer-sitemap">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={scrollToId(l.id)}
                className="text-sm font-semibold uppercase tracking-[0.15em] hover:text-[#EE443E] transition-colors"
                data-testid={`footer-link-${l.id}`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-4" data-testid="footer-socials">
            {SOCIALS.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-11 h-11 rounded-full border border-[rgba(255,255,255,.14)] flex items-center justify-center hover:bg-[#EE443E] hover:border-[#EE443E] hover:text-[#15181C] transition-colors duration-300"
                data-testid={`footer-social-${label.toLowerCase()}`}
              >
                <Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>

        <div className="footer-contacts text-sm text-white border-t border-[rgba(255,255,255,.14)] pt-10" data-testid="footer-contacts">
          <div>
            <p className="text-[11px] uppercase tracking-[0.14em] text-[var(--faint)] mb-2">КОНТАКТ</p>
            <p><a href="tel:+359883414488" className="hover:text-[var(--red)]">+359 883 414 488</a></p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.14em] text-[var(--faint)] mb-2">ИМЕЙЛ</p>
            <p><a href="mailto:hello@bulbit.co" className="hover:text-[var(--red)]">hello@bulbit.co</a></p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.14em] text-[var(--faint)] mb-2">АДРЕС</p>
            <p>София, България</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs uppercase tracking-[0.2em] text-[var(--faint)]">
          <span>© 2026 Bulb It Advertising</span>
          <span>Всички права запазени</span>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
